import React from "react";
import { Search, ArrowUpRight } from "lucide-react";
import styles from "../styles/searchFormLink.module.css";

// Only http(s) links are rendered.
export const safeSearchUrl = (url) => {
  if (!url || typeof url !== "string") return null;
  try {
    const u = new URL(url);
    return u.protocol === "https:" || u.protocol === "http:" ? url : null;
  } catch (e) {
    return null;
  }
};

const COPY = {
  results: {
    title: "See all results on the search page",
    sub: "All routes, filters and sorting for this search",
  },
  noRoutes: {
    title: "Try this search on the search page",
    sub: "Check other dates, modes and connecting routes",
  },
};

/**
 * One link to routechef.com/search-form for a chatbot search.
 * variant "results"  → under the route cards (ChatComp)
 * variant "noRoutes" → under a "No Routes Found" reply
 */
const SearchFormLink = ({ url, variant = "results", className = "" }) => {
  const href = safeSearchUrl(url);
  if (!href) return null;
  const copy = COPY[variant] || COPY.results;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`${styles["search-form-link"]} ${variant === "noRoutes" ? styles["after-bubble"] : ""} ${className}`}
      onClick={(e) => e.stopPropagation()}
    >
      <span className={styles["search-form-link-icon"]} aria-hidden="true">
        <Search size={16} />
      </span>
      <span className={styles["search-form-link-text"]}>
        <span className={styles["search-form-link-title"]}>{copy.title}</span>
        <span className={styles["search-form-link-sub"]}>{copy.sub}</span>
      </span>
      <ArrowUpRight size={18} aria-hidden="true" className={styles["search-form-link-arrow"]} />
    </a>
  );
};

export default SearchFormLink;
